import { useState, useEffect } from "react";
import { useAnalyticsStateContext } from "../../../context/AnalyticsContext";
import useConversationDurations from "../../../../../../hooks/useConversationDurations";
import AnalyticsBlock from "../AnalyticsBlock/AnalyticsBlock";
import AnalyticsGraph from "../AnalyticsGraph/AnalyticsGraph";
import AnalyticsCallDurationGraph from "../AnalyticsCallDurationGraph/AnalyticsCallDurationGraph";
import { ThreeDots } from "react-loader-spinner";
import "./AnalyticsContainer.css";

function AnalyticsContainer({ data }) {
    const { analytics, metrics_id, metrics, channel_type_id, periodChoice, firstPeriod,channel_id } = useAnalyticsStateContext();
    const { conversations, loading } = useConversationDurations({
        periodChoice: periodChoice,
        date_start: firstPeriod?.date_start,
        date_end: firstPeriod?.date_end,
        channel_id : channel_id == null ? null : channel_id
    });

    const stateSection = useState("number_of_messages");
    const [section] = stateSection;

    const sum = (object) => {
        const data = Object.values(object);
        return data.length ? data.reduce((previousValue, currentValue) => previousValue + currentValue) : 0;
    };

    const number_of_conversations = sum(analytics.number_of_conversations_stats)
    const number_of_users = sum(analytics.number_of_users_stats)
    const number_of_messages = sum(analytics.number_of_messages_stats)
    const average_duration_of_conversations = sum(analytics.average_duration_of_conversations_stats) /60
    const average_number_of_messages = sum(analytics.average_number_of_messages_stats)
    const message_per_conversation = average_number_of_messages / (Object.values(analytics.average_number_of_messages_stats).length || 1)
    const conversation_duration = average_duration_of_conversations / (Object.values(analytics.average_duration_of_conversations_stats).length || 1)
    const number_of_minutes_total = Math.ceil(sum(analytics.number_of_minutes_total_stats)) /// on arrondi a la minute superieur
    const number_of_minutes_bot   = Math.ceil(sum(analytics.number_of_minutes_bot_stats))
    const number_of_minutes_human   = Math.ceil(sum(analytics.number_of_minutes_human_stats))
    //console.log(conversation_duration);
    const number_of_unanswered_call = analytics.number_of_unanswered_call ? sum(analytics.number_of_unanswered_call) : null;


    var number_of_passing_by_block = 0;

    if (metrics_id != null) {
        const condition = metrics.conditions.filter((condition) => condition.id == metrics_id);
        const redirection = metrics.redirections.filter((redirection) => redirection.id == metrics_id);
        const categorization = (metrics.categorizations || []).filter((categorization) => categorization.id == metrics_id);

        if (condition.length == 1) {
            const result = Object.values(condition[0].values).map(
                (array) => Object.values(array).reduce((accumulator, value) => accumulator + value),
                0
            );
            number_of_passing_by_block = result.reduce((accumulator, value) => accumulator + value);
        }

        if (redirection.length) {
            const result = Object.values(redirection[0].values).map(
                (array) => Object.values(array).reduce((accumulator, value) => accumulator + value),
                0
            );
            number_of_passing_by_block = result.reduce((accumulator, value) => accumulator + value);
        }

        if (categorization.length) {
            const result = Object.values(categorization[0].values).map(
                (array) => Object.values(array).reduce((accumulator, value) => accumulator + value),
                0
            );
            number_of_passing_by_block = result.reduce((accumulator, value) => accumulator + value);
        }
    }

    useEffect(() => {
        const [section, setSection] = stateSection;

        if (section === "metrics" && metrics_id == null) {
            setSection("number_of_messages");
        } else if (section !== "metrics" && metrics_id != null) {
            setSection("metrics");
        }
    }, [metrics_id, stateSection]);
    return (
        <div className="main_elements">
            <div className="break"></div>
            <AnalyticsBlock
                className="small"
                title={channel_type_id == 3 ? "Calls" : "Conversations"}
                number={number_of_conversations}
                type="number_of_conversations"
                stateSection={stateSection}
            />
            <AnalyticsBlock
                className="small"
                title="Interactions"
                number={number_of_messages}
                type="number_of_messages"
                stateSection={stateSection}
            />
            <AnalyticsBlock
                className="small"
                title={"Interactions per " + (channel_type_id == 3 ? "call" : "conversation")}
                percentage={-4}
                number={message_per_conversation}
                type="average_number_of_interactions"
                stateSection={stateSection}
            />
            <AnalyticsBlock
                className="small"
                //title={"Total duration mean"}
                title={(channel_type_id == 3 ? "Call" : "Conversation") + " duration with AI Agent in minutes"}
                percentage={120}
                number={conversation_duration}
                type="average_duration_of_conversations"
                stateSection={stateSection}
                hoverInfo={
                    channel_type_id == 1
                        ? "The duration of web conversation is the delay between the first and the last message of the conversation"
                        : ""
                }
            />
            {/* <AnalyticsBlock className='small' title='Sum Conversation durations (Minutes)' percentage={120} number={average_duration_of_conversations/60} type='sum_duration_of_conversations' stateSection={stateSection}/> */}
            <AnalyticsBlock
                className="small"
                title="Users"
                number={number_of_users}
                type="number_of_users"
                stateSection={stateSection}
            />
            <AnalyticsBlock
                className="small"
                title={"Total duration in minutes"}
                number={number_of_minutes_total}
                type="number_of_minutes_total"
                stateSection={stateSection}
                //hoverInfo={"Total duration in " (channel_type_id == 3 ? "calls" : "conversations")}
            />
            
            <AnalyticsBlock
                className="small"
                title={"Total duration with AI Agent in minutes"}
                number={number_of_minutes_bot}
                type="number_of_minutes_bot"
                stateSection={stateSection}
            />
            <AnalyticsBlock
                className="small"
                title={"Total duration with Human in minutes"}
                number={number_of_minutes_human}
                type="number_of_minutes_human"
                stateSection={stateSection}
            />

            {number_of_unanswered_call ? (
                <AnalyticsBlock
                    className="small"
                    title="Unanswered Call"
                    number={number_of_unanswered_call}
                    type="number_of_unanswered_call"
                    stateSection={stateSection}
                />
            ) : null}
            {metrics_id ? (
                <AnalyticsBlock
                    className="small"
                    title="Number of passage"
                    number={number_of_passing_by_block}
                    type="metrics"
                    stateSection={stateSection}
                />
            ) : (
                ""
            )}
            <div className="break"></div>
            <AnalyticsGraph option={section} />

            {channel_type_id !== 1 && channel_type_id !== 2 && (
                <AnalyticsCallDurationGraph conversations={conversations} loading={loading} />
            )}
        </div>
    );
}

export default AnalyticsContainer;
